import React, { useEffect, useState } from 'react'

import { StudentHeaderContainer } from './styled'
import { useUser } from '../../context'
import { Student } from '../../types'

const StudentHeader = () => {
  const { user, userRole } = useUser()
  const [currentAttendance, setCurrentAttendance] = useState<number>(0)
  const [currentAmount, setCurrentAmount] = useState<number>(0)

  useEffect(() => {
    if (user !== null) {
      setCurrentAttendance((user as Student).currentAttendance || 0)
      setCurrentAmount((user as Student).currentAmountOfClasses || 0)
    }
  }, [user])

  return (
    <StudentHeaderContainer $userRole={userRole}>
      <div className="bublee">
        <p>
          {user
            ? `${currentAttendance} / ${currentAmount} Clases`
            : 'Loading...'}
        </p>
      </div>
    </StudentHeaderContainer>
  )
}

export default StudentHeader
